import React, { useState } from "react";
import { string } from "prop-types";
import CustomText from "pages/_components/CustomText/CustomText";

import DropdownArrow from "pages/_components/DropdownArrow";

const InfoDropdown = ({ title, description }) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const [isOpen, setIsOpen] = useState(false);

    const descriptionWithLinks = description.replace(urlRegex, (url) => `<a href="${url}" target="_blank">${url}</a>`);
    return (
        <div className="box box-shadow py-3" onClick={() => setIsOpen((lv) => !lv)}>
            <button className="btn-block" type="button">
                <h2 className="flex justify-between text-left">
                    <CustomText text={title} />
                    <DropdownArrow isActive={isOpen} />
                </h2>
            </button>
            {isOpen && (
                <>
                    <div className="horizontal-divider"> </div>
                    <p
                        className="helper-item-description"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: descriptionWithLinks }}
                    />
                </>
            )}
        </div>
    );
};

InfoDropdown.propTypes = {
    title: string.isRequired,
    description: string.isRequired,
};

export default InfoDropdown;
